
import {Component, Vue} from 'vue-property-decorator';
import {IRole, IRoleSettings} from '@/interfaces/role';
import {
  dispatchCreateGroup,
  dispatchCreateRole,
  dispatchGetDefaultRoleSetting, dispatchGetFormsAdmin, dispatchGetGroup, dispatchGetGroups, dispatchGetPermissions,
  dispatchGetRolesAdmin, dispatchUpdateGroups,
  dispatchUpdateRole,
} from '@/store/admin/actions';
import {
  readAdminForms,
  readAdminGroup,
  readAdminRole,
  readAdminRoles,
  readDefaultRoleSettings,
} from '@/store/admin/getters';
import {rules} from '@/utils';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import RoleSettings from '@/components/extras/RoleSettings.vue';
import {dispatchGetUserProfile} from '@/store/main/actions';
import {IGroup} from '@/interfaces/group';
import {readPermissions} from '@/store/main/getters';
import {IPermission} from '@/interfaces/permission';
import {IForm} from '@/interfaces/form';
import ImportRoleSettings from '@/components/dialogs/ImportRoleSettings.vue';
import ImportGroupPermissions from '@/components/dialogs/ImportGroupPermissions.vue';

@Component({
  components: {ImportGroupPermissions, ImportRoleSettings, RoleSettings, DefaultHelp},
})
export default class CRUDGroup extends Vue {

  private get permissions() {
    return readPermissions(this.$store);
  }

  get forms() {
    return readAdminForms(this.$store);
  }
  private group: IGroup = {} as IGroup;
  private rules: any = rules;

  private valid: boolean = false;
  private title: string = `${this.$t('crud.create')} ${this.$t('group')}`;
  private groupId: number = -1;
  private permissionsToSave: number[] = [];
  private formsToSave: number[] = [];


  public async mounted() {
    this.groupId = this.$router.currentRoute.params.id as unknown as number;
    await dispatchGetPermissions(this.$store);
    await dispatchGetFormsAdmin(this.$store);

    if (this.groupId > 0) {
      await dispatchGetGroup(this.$store, this.groupId);
      this.title = `${this.$t('crud.update')} ${this.$t('group')}`;
      this.group = readAdminGroup(this.$store)(+this.groupId) as IGroup;

      // @ts-ignore
      this.permissionsToSave = this.group.permissions.map((item: IPermission) => item.id);
      // @ts-ignore
      this.formsToSave = this.group.forms.map((item: IForm) => item.id);
      // this.permissionsToSave = []
    } else {
      this.group = {} as IGroup;
      this.groupId = 0;
    }

  }

  public beforeRouteLeave(to, from, next) {
    this.group = {} as IGroup;
    this.title = `${this.$t('crud.create')} ${this.$t('group')}`;
    this.groupId = 0;
    next();
  }

  public importFunction(val) {
    if (val && val instanceof Object) {
      this.permissionsToSave = val?.permissions.map((item: IPermission) => item.id);
    }
  }

  private cancel() {
    this.$router.back();
  }

  private reset() {
    this.group = {} as IGroup;
  }

  private async submit() {
    const form: any = this.$refs.form_crud_group;
    if (await form.validate()) {
      const groupToSave = {
        ...this.group,
        permissions: this.permissionsToSave,
        forms: this.formsToSave,
      } as unknown as IGroup;

      if (this.groupId > 0) {
        if (await dispatchUpdateGroups(this.$store, groupToSave)) {
          await dispatchGetUserProfile(this.$store);
          await this.$router.push({name: 'main-admin-group-list'});
        }
      } else {
        if (await dispatchCreateGroup(this.$store, groupToSave)) {
          await this.$router.push({name: 'main-admin-group-list'});
        }
      }
    }
  }


}
